export default "__VITE_ASSET___app/immutable/assets/logotype-dark.D862MXBL.svg__"